export default __webpack_public_path__ + "static/media/burn.d6e6cf29.png";